import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
  resource,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsDefinedNotEmptyPipe, ResolvableModal } from '@softline/ui-core';
import { ArtikelMenge } from '@softapps/lager/core';
import { KommissionierungService } from '../../services/kommissionierung.service';
import { ResourceContainerComponent } from '@softapps/core';
import { MengenEingabeComponent } from '@softline/application';
import { isDefinedNotEmpty } from '@softline/core';

@Component({
  selector: 'soft-additional-item-quantity-modal',
  imports: [
    CommonModule,
    ResourceContainerComponent,
    MengenEingabeComponent,
    IsDefinedNotEmptyPipe,
  ],
  templateUrl: './additional-item-quantity-modal.component.html',
  styleUrl: './additional-item-quantity-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdditionalItemQuantityModalComponent extends ResolvableModal<ArtikelMenge> {
  readonly id = input<number>();
  readonly quantity = model<number>(1);

  readonly service = inject(KommissionierungService);

  readonly resource = resource({
    params: () => this.id(),
    loader: async ({ params: id }) => {
      return this.service.loadArtikelMenge(id);
    },
  });

  protected readonly isDefinedNotEmpty = isDefinedNotEmpty;

  closeModal(): void {
    const value = this.resource.value();

    if (isDefinedNotEmpty(value)) {
      this.resolve({
        ...value,
        menge: this.quantity(),
        menge_lg: this.quantity(),
      });
    }
  }
}
